import { AxiosResponse } from "axios";
import toast from "react-hot-toast";
import { call, put, select, takeLatest } from "redux-saga/effects";
import { AppService } from "src/services/app";
import { getBaseUrl } from "../selectors/features/app";
import {
  fetchHistoryFailure,
  fetchHistorySuccess,
} from "../slices/features/history";
import { RequestTypes } from "../types";

const historyService = new AppService();

function* fetchHistory(action: any) {
  const { payload } = action;

  try {
    const baseUrl: string = yield select(getBaseUrl);

    const response: AxiosResponse<any> = yield call(
      historyService.fetchHistory,
      baseUrl,
      payload
    );

    yield put(fetchHistorySuccess({ ...response }));
  } catch (error: any) {
    const { statusCode, statusText } = error;

    const {
      data: {
        errors: { message },
      },
    } = error;

    toast.error(Array.isArray(message) ? message[0] : message);

    yield put(fetchHistoryFailure({ statusCode, statusText }));
  }
}

export function* watchFetchHistory() {
  yield takeLatest(RequestTypes.HISTORY_REQUEST, fetchHistory);
}
